import {REQUEST} from "../../../util/Request";
import * as types from "./types";

export const BusquedaSolicitudReducer = (state = {}, action) => {
  switch (action.type) {
    case types.CONSULTAR_SOLICITUD:
      return {
        ...state,
        estadoConsultarSolicitud: REQUEST.PENDING
      };
    case types.SOLICITUD_CONSULTADA:
      return {
        ...state,
        solicitud: action.payload,
        estadoConsultarSolicitud: REQUEST.SUCCESS,
        estadoSolicitud: action.payload.estado
      };
    case types.ERROR_CONSULTANDO_SOLICITUD:
      return {
        ...state,
        estadoConsultarSolicitud: REQUEST.ERROR,
        errorConsultarSolicitud: action.error
      };
    case types.CONSULTAR_TIPOS_SOLICITUD:
      return {
        ...state,
        estadoConsultarTiposSolicitud: REQUEST.PENDING,
      };
    case types.TIPOS_SOLICITUD_CONSULTADOS:
      return {
        ...state,
        tiposSolicitud: action.payload,
        estadoConsultarTiposSolicitud: REQUEST.SUCCESS
      };
    case types.ERROR_CONSULTANDO_TIPOS_SOLICITUD:
      return {
        ...state,
        estadoConsultarTiposSolicitud: REQUEST.ERROR,
        errorConsultarTiposSolicitud: action.error
      };
    case types.LIMPIAR_BUSQUEDA_SOLICITUD:
      return {
        ...state,
        solicitud: undefined,
        estadoConsultarSolicitud: undefined,
        errorConsultarSolicitud: undefined,
        tiposSolicitud: undefined,
        estadoConsultarTiposSolicitud: undefined,
        errorConsultarTiposSolicitud: undefined,
        estadoSolicitud: undefined
      };
    default:
      return state;
  }
};
